export default "__VITE_ASSET__FlHg28YX__"